import React from "react";
import { ToggleButtonGroup, ToggleButton } from "@common-ui/ui";
import { ViewList, GridView, TableRows } from "@mui/icons-material";
export const ToggleViews = (props) => {
  return (
    <ToggleButtonGroup
      value={props.view}
      exclusive
      onChange={props.handleView}
      aria-label="text views"
      size="small"
    >
      <ToggleButton value="list-view" aria-label="list view">
        <ViewList />
      </ToggleButton>
      <ToggleButton value="table-view" aria-label="table view">
        <TableRows />
      </ToggleButton>
      <ToggleButton value="card-view" aria-label="card view">
        <GridView />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
